// src/pages/NotFoundPage.tsx
import { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';



const NotFoundPage = () => {
    const navigate = useNavigate();
      const [isLoggedIn, setLoggedin] = useState<boolean>(false);

    return (
        <>
            <Header />
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="100vh"
                textAlign="center"
                px={2}
            >
                <Typography variant="h2" fontWeight={700} gutterBottom>
                    404
                </Typography>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                    Page Not Found
                </Typography>
                <Typography variant="body1" mb={4}>
                    The page you are looking for doesn't exist or has been moved.
                </Typography>
                <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                    Go to Home Page
                </Button>
            </Box>
        </>

    );
};

export default NotFoundPage;
